function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNumbers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 178.58 178.58"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m66.34 151.34-39.1-39.11A73.69 73.69 0 0 1 27.24 8l39.1 39.11-13 13a18.43 18.43 0 0 0 0 26.07l39.1 39.11a18.43 18.43 0 0 0 26.07 0l13-13 39.1 39.11a73.69 73.69 0 0 1-104.27-.06Z",
  style: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "11.25px"
  },
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
})));
export default SvgNumbers;